/**
 * ImageKit URL transformation utilities.
 * All transforms insert a /tr:.../ segment after the base endpoint.
 *
 * Usage:
 *   ikProfile(url)         → 200×200 face-cropped square (profile photos)
 *   ikThumb(url, w, h)     → arbitrary resize (logos, banners)
 */

const IK_ENDPOINT = process.env.REACT_APP_IMAGEKIT_URL_ENDPOINT || '';

function ikTransform(url, transform) {
  if (!url || !url.includes('ik.imagekit.io')) return url;
  if (!IK_ENDPOINT || !url.startsWith(IK_ENDPOINT)) return url;
  // Remove any existing /tr:.../ before adding a new one
  const cleaned = url.replace(/\/tr:[^/]+/, '');
  const path = cleaned.slice(IK_ENDPOINT.length).replace(/^\//, '');
  return `${IK_ENDPOINT}/tr:${transform}/${path}`;
}

/** 200×200 face-crop for profile photos */
export function ikProfile(url, size = 200) {
  return ikTransform(url, `w-${size},h-${size},fo-face`);
}

/** Resize to exact dimensions (logos, thumbnails) */
export function ikThumb(url, w, h) {
  return ikTransform(url, `w-${w},h-${h},fo-auto`);
}
